// extracted by mini-css-extract-plugin
export default {"title":"titles_title__GyKcE"};